export default __webpack_public_path__ + "static/media/tms_system_logo.733db7d3.png";